/**
 * Scroll suave a un elemento
 * @param {string} targetId - ID del elemento destino
 * @param {number} offset - Offset superior (default: 50px para header fijo)
 */
export const smoothScrollTo = (targetId, offset = 50) => {
  const element = document.querySelector(targetId);
  if (!element) return;

  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
};

/**
 * Hook para manejar scroll suave en links
 * @param {Event} event - Evento del click
 * @param {string} href - href del link
 */
export const handleSmoothScroll = (event, href) => {
  if (href?.startsWith('#')) {
    event.preventDefault();
    smoothScrollTo(href);
  }
};
